<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-02-23 11:05:55
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2024-04-07 17:10:27
 * @FilePath: \qctsw-vue\packages\app\src\pages\news\media\[id].vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script setup lang='ts'>
import { APP_ROUTER, imageTransform } from '@qctsw/common'
import { contentRemoveTags } from '@qctsw/utils'
import { logicMediaDetail } from '@/logic/news/media'
import { callWithNuxt } from '#app'

import { NEWS_MEDIA_SITE_META, SITE_NAME } from '@/shared/site'

const nuxtApp = useNuxtApp()
const { changeMeta } = useSite(NEWS_MEDIA_SITE_META)

const {
  id,
  page,
  state,
  detailData,
  pageData,
  pagination,
  getMediaDetail,
  getMediaArticleList,
} = logicMediaDetail()

async function initHandler() {
  await getMediaDetail()
  await callWithNuxt(nuxtApp, getMediaArticleList, [page.value])

  changeMeta({
    title: `${detailData.value?.name} - ${SITE_NAME}`,
    description: contentRemoveTags(detailData.value?.intro) || NEWS_MEDIA_SITE_META.description,
    keywords: [detailData.value?.name, ...NEWS_MEDIA_SITE_META.keywords].filter(Boolean) as string[],
  })
}

await initHandler()
</script>

<template>
  <div bg-slate-1>
    <div class="public-container public-page flex">
      <div class="flex-grow min-w-0">
        <UtilLoadState :state="state" :reload-handler="initHandler">
          <template v-if="detailData">
            <div class="p-sm mb-lg flex bg-white rounded-md ">
              <img
                class="flex-shrink-0 mr-4 rounded-1.5 w-40 h-25"
                :src="imageTransform(detailData.coverImgUrl)"
                fit="contain"
              >
              <div>
                <h2 class="font-bold text-5 block">
                  {{ detailData.name }}
                </h2>
                <p mt-1 text-slate-8 text-3.5>
                  {{ contentRemoveTags(detailData.intro) || '暂无节目简介' }}
                </p>
              </div>
            </div>
            <div v-if="pagination" class="">
              <UtilLoadState
                :state="pagination?.pagination.status"
                :reload-handler="() => getMediaArticleList(page)"
              >
                <template #loading>
                  <SkeletonArticle v-for="v in 10" :key="v" mb-sm />
                </template>
                <template v-if="pageData && pageData.length">
                  <!-- <ArticleItem
                    v-for="(val, idx) in pageData" :key="idx"
                    :item="val" :show-author="false"
                    class="border-b-1 border-slate-1 py-sm"
                  /> -->
                  <div class="grid grid-cols-2">
                    <NuxtLink
                      v-for="(val, idx) in pageData"
                      :key="idx"
                      :to="APP_ROUTER.newsDetail(val.id)" :class="(idx % 2) === 0 ? '' : 'ml-5'" class="bg-white mt-5   flex flex-col p-5 rounded-md"
                      :item="val"
                    >
                      <p class="text-center text-4.5 mb-2 font-bold">
                        {{ val.title }}
                      </p>
                      <img
                        loading="lazy" :alt="val.title" class="w-full h-full rounded-md"
                        :src="imageTransform(val.coverImgUrl, { width: 208, height: 117 })"
                      >
                    </NuxtLink>
                  </div>
                </template>
              </UtilLoadState>
              <BasicPagination
                v-if="pagination && pagination.pagination.pageCount"
                class="mt-sm"
                :page="pagination.pagination.page"
                :total="pagination.pagination.pageCount"
                :to="(page) => APP_ROUTER.newsMediaDetail(id, { page })"
              />
            </div>
          </template>
          <BasicEmpty v-else text="未找到相关媒体信息" />
        </UtilLoadState>
      </div>
      <div class="flex-shrink-0 w-[calc(100%-53rem)] pl-xl">
        <ClientOnly>
          <RankHotNews :embedded="false" class="mb-sm" />
          <RankAuthorCorrelation :embedded="false" class="sticky top-25" />
        </ClientOnly>
      </div>
      <UtilShareFixed />
    </div>
  </div>
</template>

<style lang='scss' scoped>

</style>
